<template>
  <div class="pagination">
    <a-empty
      v-if="isEmpty"
      style="padding-top: 52px;padding-bottom: 12px;"
      :description="false"
      :image-style="imageStyle"
    >
      <img
        slot="image"
        :src="enptyImage || emptyImg"
        alt=""
      >
      <p style="margin-top: 24px;color: #5E668D;">{{ desc }}</p>
      <a-button
        class="btn"
        type="primary"
        v-if="btnTxt"
        @click="$emit('empty')"
      >
        {{ btnTxt }}
      </a-button>
    </a-empty>
    <a-spin
      :spinning="spinning"
      v-else
    >
      <slot></slot>
      <div class="d-flex justify-between mt-6 mb-6">
        <span
          v-show="total > 0"
          class="font-14"
          style="color: rgba(0,0,0,0.6);"
        >共{{ total }}条{{ typeMenu[type] }}</span>
        <a-pagination
          v-show="total > 0"
          v-model="current"
          :defaultPageSize="size"
          :total="total"
          show-less-items
        />
      </div>
    </a-spin>
  </div>
</template>
<script>
import emptyImg from '@/assets/empty.png'
export default {
  name: 'ZPagination',
  props: {
    type: {
      type: String,
      default: 'T'
    },
    enptyImage: {
      type: String,
      default: ''
    },
    empty: {
      type: Boolean,
      default: true,
    },
    spinning: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 1
    },
    desc: {
      type: String,
      default: ''
    },
    btn: {
      type: Boolean,
      default: false
    },
    btnTxt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      typeMenu: {
        'T': '贴子',
        'C': '回复'
      },
      emptyImg,
      current: 1,
      imageStyle: {
        width: '166px',
        height: '136px',
        margin: '0 auto'
      }
    }
  },
  computed: {
    isEmpty () {
      if (!this.empty) return this.empty
      return !this.spinning && !this.total
    },
  },
  watch: {
    current (val) {
      this.$emit('loadData', val)
    },
  },
  mounted () {

  },
  methods: {}
}
</script>
<style lang="less" scoped>
.btn {
  height: 24px;
  line-height: 24px;
  margin-top: 24px;
  border-radius: 3px;
  font-size: 12px;
  background-color: #1564FF;
}
.pagination {
    min-height: 150px;
   /deep/.ant-spin-dot {
      margin-top: 24px !important;
    }
    // .ant-pagination {
      // margin-top: 16px;
      // text-align: center;
    // }
}
</style>
